module.exports = __webpack_public_path__ + "img/hakhak_app_5.9b97e547.png";